import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Bot, User, Clock, Download, Copy, RotateCcw, Bookmark } from 'lucide-react';

const MessageBubble = ({
  message,
  index,
  messagesArray,
  bookmarkedIds,
  formatTime,
  exportToMarkdown,
  copyToClipboard,
  regenerateResponse,
  bookmarkConversation
}) => {
  const isUser = message.sender === 'user';

  const getUserMessage = () => {
    if (!isUser && index > 0) {
      for (let i = index - 1; i >= 0; i--) {
        if (messagesArray[i].sender === 'user') {
          return messagesArray[i];
        }
      }
    }
    return null;
  };

  const userMessage = getUserMessage();

  return (
    <div className={`message-wrapper ${isUser ? 'user-wrapper' : 'lumi-wrapper'}`}>
      <div className={`message-bubble ${isUser ? 'user-bubble' : 'lumi-bubble'}`}>
        <div className="message-header">
          <div className="sender-info">
            {isUser ? (
              <><User size={16} /> You</>
            ) : (
              <><Bot size={16} /> Lumi</>
            )}
          </div>
          <div className="message-time">
            <Clock size={12} />
            {formatTime(message.timestamp)}
          </div>
        </div>
        <div className="message-content">
          {isUser ? (
            <p>{message.text}</p>
          ) : (
            <ReactMarkdown
              components={{
                code({node, inline, className, children, ...props}) {
                  const match = /language-(\w+)/.exec(className || '')
                  return !inline && match ? (
                    <SyntaxHighlighter
                      style={tomorrow}
                      language={match[1]}
                      PreTag="div"
                      {...props}
                    >
                      {String(children).replace(/\n$/, '')}
                    </SyntaxHighlighter>
                  ) : (
                    <code className={className} {...props}>
                      {children}
                    </code>
                  )
                }
              }}
            >
              {message.text}
            </ReactMarkdown>
          )}
        </div>

        {!isUser && userMessage && (
          <div className="message-actions">
            <button
              className="action-button"
              onClick={() => exportToMarkdown(userMessage, message)}
              title="Export"
            >
              <Download size={16} />
            </button>
            <button
              className="action-button"
              onClick={() => copyToClipboard(userMessage, message)}
              title="Copy"
            >
              <Copy size={16} />
            </button>
            <button
              className="action-button"
              onClick={() => regenerateResponse(userMessage, index)}
              title="Regenerate"
            >
              <RotateCcw size={16} />
            </button>
            <button
              className={`action-button ${bookmarkedIds.has(message.eventId) ? 'bookmarked' : ''}`}
              onClick={() => bookmarkConversation(message.eventId)}
              title="Bookmark"
            >
              <Bookmark size={16} fill={bookmarkedIds.has(message.eventId) ? 'currentColor' : 'none'} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
